// Declare a typed use selector providing the root state
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { RootState } from 'store/store';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
